// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { getSplitToggle } from './index';

export const getToggle = async (country: string) => {
  if (window.addiFeatureToggles) {
    return window.addiFeatureToggles;
  } else {
    window.addiFeatureToggles = await getSplitToggle(country);
    return window.addiFeatureToggles;
  }
};
